import { useQuery } from '@tanstack/react-query';

import { fetchMyStatus } from '../api/fetch-my-status.js';
import { meKeys } from './keys.js';

export function myStatusQueryDefinition() {
  return {
    queryKey: meKeys.status(),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchMyStatus(signal),
    meta: {
      toast: {
        title: 'Could not load account status',
        description: 'Your account status could not be fetched.',
      },
    },
  } as const;
}

export function useMyStatusQuery() {
  return useQuery(myStatusQueryDefinition());
}
